/* eslint-disable jsx-a11y/no-distracting-elements */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Tree from 'react-animated-tree';
import Toast from '../components/toast';
import Header from './sub_components/main/header';
import Footer from './sub_components/main/footer';
import MPModel from './sub_components/masterPasswordModel';
import * as casinoControlService from '../services/casinoControlService'
import { casinoList } from '../configs/casinoShowList';

class CasinoControl extends Component {
   constructor(props) {
      super(props);
      this.state = {
         uid: "",
         marquee: "",
         toastMsg: "",
         toastType: "",
         showToast: false,
         openPopup: true,
         mpassword: "",
         locks: {
            "PROVIDER": [],
            "GAME": []
         },
         ip1: [],
         ip2: [],
         isCurUser: false,
         fullLockList: []
      };
   }
   showToast(msg, type) {
      let self = this
      this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
         setTimeout(() => {
            self.setState({ toastMsg: "", toastType: "", showToast: false })
         }, 3000);
      })
   }
   async componentDidMount() {
      let userData = localStorage.getItem("tokenData")
      userData = JSON.parse(userData)
      if (!(!!userData && !!userData.sub)) {
         localStorage.clear();
         this.props.history.push("/auth")
      } else {
         let ip1 = await casinoControlService.getIPGames()
         let ip2 = await casinoControlService.getIP2Games()
         let uid = this.props.match.params.user_id
         // debugger
         this.setState({ uid: uid, cuid: userData.sub, ip1: ip1, ip2: ip2 }, () => {
            this.loadLockData()
         })
      }
   }

   async loadLockData() {
      let allLocks = []
      if (this.state.uid === this.state.cuid) {
         let myLock = await casinoControlService.getCreatedByMe()
         let parentLock = await casinoControlService.getCreatedByParent()
         allLocks = myLock.concat(parentLock)
         this.setState({ isCurUser: true, fullLockList: myLock })
      } else {
         allLocks = await casinoControlService.getControlByUser(this.state.uid)
         this.setState({ fullLockList: allLocks })
      }
      allLocks = allLocks.filter((lk, i) => {
         return lk.username === this.state.uid
      })
      let lockData = {
         "PROVIDER": [],
         "GAME": []
      }
      Array.prototype.forEach.call(allLocks, (lk) => {
         if (lk.controlType === "PROVIDER") {
            if (!lockData["PROVIDER"]) {
               lockData["PROVIDER"] = [lk.provider]
            } else {
               lockData["PROVIDER"].push(lk.provider)
            }
         } else if (lk.controlType === "GAME") {
            if (!lockData["GAME"]) {
               lockData["GAME"] = [lk.gameId]
            } else {
               lockData["GAME"].push(lk.gameId)
            }
         }
      })
      this.setState({ locks: lockData })
   }
   //locks
   createLock(body) {
      casinoControlService.addControl(body, this.state.mpassword).then((res) => {
         if (!res.isSuccess) {
            if (res.exception.message === "Invalid master Password") {
               this.props.notify(res.exception.message, "error")
               this.setState({ openPopup: true })
            } else if (res.exception.message === "you can not update betlock") {
               this.props.notify("Invalid operation, please contact upperline.", "error")
            } else {
               this.props.notify(res.exception.message, "error")
            }
         } else {
            this.props.notify("Lock updated successfully.", "success")
            this.loadLockData()
         }
      })
   }
   removeLock(lock) {
      if (this.state.mpassword === "") {
         this.setState({ openPopup: true })
         return false
      }
      lock.betLock = false

      let body = lock

      this.createLock(body)
   }
   //Provider Lock
   providerLock(provider, lock) {
      if (this.state.mpassword === "") {
         this.setState({ openPopup: true })
         return false
      }
      let body = {
         "controlType": "PROVIDER",
         "provider": provider,
         "betLock": lock,
         "username": this.state.uid
      }
      this.createLock(body)
   }
   //Game Lock
   gameLock(game, provider, lock) {
      if (this.state.mpassword === "") {
         this.setState({ openPopup: true })
         return false
      }
      let body = {
         "controlType": "GAME",
         "provider": provider,
         "gameId": game,
         "betLock": lock,
         "username": this.state.uid
      }
      this.createLock(body)
   }
   render() {
      let locks = this.state.locks
      return (
         <>
            <body className="bethubs">
               <Header history = {this.props.history} />
               <div className="wrapper gmctrl">
                  {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                  <div className="container-fluid container-padding-0">
                     <div className="row main-box">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
                           <div className="main-">
                              <div className="row analysis-running-market mt-1">
                                 <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    <fieldset className="mt-1">
                                       <legend>Provider:</legend>
                                       <div className="row">
                                          <div className="col-12 col-sm-12 col-md-12">
                                             <ul className="game-control betgamecontrol">
                                                {
                                                   casinoList.map((itm, i) => {
                                                      return(itm.show &&
                                                         <li key={i}>
                                                            <span className="text-black font-14 mr-1">{itm.displayName}</span>
                                                            <span className="betlock1">
                                                               <label className="checkboxx">
                                                                  <input onChange={() => { this.providerLock(itm.provider, locks.PROVIDER.indexOf(itm.provider) === -1) }} type="checkbox" tabIndex="" checked={locks.PROVIDER.indexOf(itm.provider) !== -1} />
                                                                  <span className="checkmark1"></span>
                                                               </label>
                                                            </span>
                                                         </li>
                                                      );
                                                   })
                                                }

                                                {/* <li>
                                                   <span className="text-black font-14 mr-1">Indian Poker</span><span className="betlock1"><label className="checkboxx"><input onChange={() => { this.providerLock("LOTUS", locks.PROVIDER.indexOf("LOTUS") === -1) }} type="checkbox" tabIndex="" checked={locks.PROVIDER.indexOf("LOTUS") !== -1} /><span className="checkmark1"></span></label></span>
                                                </li>
                                                {/* <li>
                                                                    <span className="text-black font-14 mr-1">Indian Poker 2</span><span className="betlock1"><label className="checkboxx"><input onChange={() => { this.providerLock("SUPERNOVA", locks.PROVIDER.indexOf("SUPERNOVA") === -1) }} type="checkbox" tabIndex="" checked={locks.PROVIDER.indexOf("SUPERNOVA") !== -1} /><span className="checkmark1"></span></label></span>
                                                                </li> *}
                                                <li>
                                                   <span className="text-black font-14 mr-1">Casino</span><span className="betlock1"><label className="checkboxx"><input onChange={() => { this.providerLock("DRC", locks.PROVIDER.indexOf("DRC") === -1) }} type="checkbox" tabIndex="" checked={locks.PROVIDER.indexOf("DRC") !== -1} /><span className="checkmark1"></span></label></span>
                                                </li>
                                                <li>
                                                   <span className="text-black font-14 mr-1">Evolution</span><span className="betlock1"><label className="checkboxx"><input onChange={() => { this.providerLock("EVOLUTION", locks.PROVIDER.indexOf("EVOLUTION") === -1) }} type="checkbox" tabIndex="" checked={locks.PROVIDER.indexOf("EVOLUTION") !== -1} /><span className="checkmark1"></span></label></span>
                                                </li> */}
                                                {/* <li>
                                                   <span className="text-black font-14 mr-1">SportBook</span><span className="betlock1"><label className="checkboxx"><input onChange={() => { this.providerLock("DIGITAIN", locks.PROVIDER.indexOf("DIGITAIN") === -1) }} type="checkbox" tabIndex="" checked={locks.PROVIDER.indexOf("DIGITAIN") !== -1} /><span className="checkmark1"></span></label></span>
                                                </li> */}
                                             </ul>
                                          </div>
                                       </div>
                                    </fieldset>
                                 </div>

                                 <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    <div className="font-14 text-blue font-weight-bold gamelocktitle mt-2">
                                       <span>Casino Control</span>
                                       <div className="font-14 text-darkblue font-weight-bold gamelocktitle ml-4 mt-2">
                                          <Tree content={<span className={"betlock"}>
                                             <span className="treeviewtext">{"Indian Poker"}</span>
                                          </span>} >
                                             {this.state.ip1.map((game, i) => {
                                                return (
                                                   <Tree content={<span className={"betlock"}>
                                                      <span className="treeviewtext">{game.gameName} </span>
                                                      <label className="checkboxx"><input onChange={() => { this.gameLock(game.gameId, "LOTUS", locks.GAME.indexOf(game.gameId) === -1) }} type="checkbox" tabIndex="" checked={locks.GAME.indexOf(game.gameId) !== -1} /><span className="checkmark1"></span></label>
                                                   </span>} />
                                                )
                                             })}
                                          </Tree>
                                          {/* <Tree content={<span className={"betlock"}>
                                                            <span className="treeviewtext">{"Indian Poker 2"}</span>
                                                        </span>} >
                                                            {this.state.ip2.map((game, i) => {
                                                                return (
                                                                    <Tree content={<span className={"betlock"}>
                                                                        <span className="treeviewtext">{game.gameName} </span>
                                                                        <label className="checkboxx"><input onChange={() => { this.gameLock(game.gameId, "SUPERNOVA", locks.GAME.indexOf(game.gameId) === -1) }} type="checkbox" tabIndex="" checked={locks.GAME.indexOf(game.gameId) !== -1} /><span className="checkmark1"></span></label>
                                                                    </span>} />
                                                                )
                                                            })}
                                                        </Tree> */}
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                           {this.state.fullLockList.length > 0 && <div className="table-responsive  max-hight">
                              <table className="w-100 table-sm font-12 text-black">
                                 <thead className="">
                                    <tr className="bg-dark text-white bg-dark1">
                                       <td>User</td>
                                       <td>Type</td>
                                       <td>Discription</td>
                                       <td>Action</td>
                                    </tr>
                                 </thead>
                                 <tbody>
                                    {this.state.fullLockList.map((lock) => {
                                       return (
                                          <tr className="">
                                             <td>{lock.username}</td>
                                             <td>{lock.controlType}</td>
                                             <td>{lock.description}</td>
                                             <td><span title="Remove Lock" className="action-box red-box text-white" data-toggle="modal" onClick={() => { this.removeLock(lock) }} data-target="#mypassword">Del</span></td>
                                          </tr>
                                       )
                                    })}
                                 </tbody>
                              </table>
                           </div>}
                        </div>

                     </div>
                  </div>
               </div>
               {this.state.openPopup && <MPModel closePopup={() => { this.setState({ openPopup: false }) }} setMasterPassword={(mp) => { this.setState({ mpassword: mp, openPopup: false }) }} />}
               <Footer />
            </body>
         </>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(CasinoControl);